import { useRef } from 'react'
import { Box, Button, Text } from 'theme-ui'
import { useNavigate } from 'react-router-dom'
import { Formik, Form } from 'formik'
import { object, string } from 'yup'

import useCurrentUserStore from '../../stores/currentUser'
import { notifyErrorAPI, notifySuccess } from '../../components/Notif'
import { loginFunction } from '../../api/loginFunction'
import FormikInput from '../../components/Formik/FormikInput'
import { useMutation } from 'react-query'

export default function LoginPage() {
  const ref = useRef<HTMLInputElement>(null)
  const { setCurrentUser } = useCurrentUserStore()
  const navigate = useNavigate()

  const loginM = useMutation(loginFunction, {
    onSuccess,
    onError,
  })

  function handleSubmit(values) {
    loginM.mutate({ auth: { email: values.email, password: values.password } })
  }

  function onSuccess(props: any) {
    setCurrentUser(props.data)
    notifySuccess('Login successfull')
    navigate('/')
  }

  function onError(error) {
    notifyErrorAPI(error)
  }

  const validationSchema = object({
    email: string().trim().required('Email tidak boleh kosong'),
    password: string().trim().required('Password tidak boleh kosong'),
  })

  return (
    <Formik
      initialValues={{ email: '', password: '' }}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ errors, isValid, setFieldValue }) => {
        return (
          <Form>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: ['start', 'center'],
                minHeight: '95vh',
                maxHeight: '100%',
              }}
            >
              <Box
                bg="white"
                sx={{
                  width: ['90%', '40%'],
                  borderRadius: 'm',
                  p: 4,
                  textAlign: 'center',
                  boxShadow: '0px 0px 9px 2px rgba(0,0,0,0.25)',
                }}
              >
                <Text as="h1" variant="heading" color="primary" mb={4}>
                  Sign In
                </Text>

                <FormikInput
                  ref={(r) => (ref.current = r)}
                  name="email"
                  label="Email"
                  autoFocus
                  errorMessage={errors.email}
                  mb={2}
                  onChange={(e) => setFieldValue('email', e.target.value)}
                />

                <FormikInput
                  name="password"
                  label="Password"
                  type="password"
                  errorMessage={errors.password}
                  onChange={(e) => setFieldValue('password', e.target.value)}
                />

                <Button
                  type="submit"
                  variant="primary"
                  mt="4"
                  sx={{ width: '100%' }}
                  disabled={!isValid}
                >
                  Sign In
                </Button>
              </Box>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}
